<template>
    <button  type="button" class="btn btn-sm border border-pmes-danger  btn-cadastrar-datatable" title="Inserir" data-bs-toggle="modal" :data-bs-target="'#' + modal "  @click="gerarBoletim" > 
        <i class="fa fa-file-pdf fa-2x bi fs-2x text-pmes-danger"></i>  Pdf dos alunos
    </button>  
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true"  >  
        <div class="modal-dialog" style="max-width:1700px;">  
            <div class="modal-content"  style="min-height: 450px;">  
                <div class="modal-header"> 
					<h2>Pdf dos alunos</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg" />
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y" :key="identificador">
                    <CardRh >  
                        <div class="col-12 col-md-12  min-h-1850px"> 
                            <iframe :src="url" width="100%" height="700px"   style="border: none;"></iframe>   
                        </div>   
                    </CardRh> 
				</div>   
			</div> 
		</div> 
	</div> 
</template>

<script lang="ts">  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 
    import UsuarioService from   "@/service/v1/seguranca/UsuarioService"  

    @Options({
        name: "AlunosPdf",
        components: {  CardRh  },   
    }) 
    export default class AlunosPdf extends Vue { 
        
        @authStore.Getter
		public token!: any  
  
        public service = new UsuarioService(); 

        @Prop( ) readonly turma!: any   
        @Prop( ) readonly pelotao!: any   

        public identificador = 1 ;   
         
        public url: any = null;
        public modal: any = "modal_pdf_lista_alunos";
  
        public gerarBoletim(){ 
            this.url =   null; 
            if(!this.turma || !this.pelotao){
                return;
            }
            setTimeout(() => {
                this.url = this.service.getApiUrl() + '/Dados/Pdf?turmaId=' + this.turma + '&pelotao=' + this.pelotao +   '&token=' + this.token ; 
                this.identificador++;
            }, 2 );  
        }
    } 
</script> 


<style scoped>  
    .btn-sm{
        margin-left: 10px; 
        padding: 0.55rem 1.25rem;
    } 
    .btn-flex-full{
        max-width: 100%;
        min-width: 100%;
    } 
    .start-90{
        left: 97% !important;
    }
</style>